<template>
  <Layout>
    <GoBack
      class="my-auto mb-5"
      :text="isCareers ? 'shottracker careers' : 'shottracker news'"
      :link="isCareers ? 'Careers' : 'Media'"
    />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <div>
      <div v-if="isCareers">
        <p class="text-lg mb-5">Upload new job posting</p>

        <JobPostingsForm
          @handleSubmit="handleSubmit"
          @getFile="getFile"
          :form="careersForm"
        />
      </div>
      <div v-else>
        <p class="text-lg my-5">Upload new press release</p>

        <PressReleaseForm
          @handleSubmit="handleSubmit"
          @getFile="getFile"
          :form="pressReleaseForm"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import PressReleaseForm from "./Media/PressReleases/PressReleaseForm.vue";
import JobPostingsForm from "./Careers/JobPostingsForm.vue";
import Layout from "./Layout.vue";
import GoBack from "./GoBack.vue";
import LoadingSpinner from "./LoadingSpinner.vue";
import { uuid } from "vue-uuid";
import { mapActions, mapGetters } from "vuex";
import loader from "../mixins/loader";

export default {
  name: "UploadNewFile",
  mixins: [loader],

  components: {
    PressReleaseForm,
    JobPostingsForm,
    Layout,
    GoBack,
    LoadingSpinner,
  },

  data() {
    return {
      isCareers: false,

      pressReleaseForm: {
        header: "",
        subheader: "",
        body: "",
        date: "",
        featured: false,
        homeFeatured: false,
        link: "",
        image: null,
        file: null,
      },

      careersForm: {
        applyLink: "",
        file: null,
        role: "",
        overview: "",
        responsibilities: "",
        skills: "",
        reportsTo: "",
        location: "",
        compensation: "",
      },
    };
  },

  computed: {
    ...mapGetters(["pressReleasesID", "careersID"]),
  },

  methods: {
    ...mapActions(["addFileToS3"]),

    getFile(files) {
      const file = files.length === 1 ? files[0] : "";

      if (this.isCareers) {
        this.careersForm.file = file;
      } else {
        this.pressReleaseForm.file = file;
      }
    },

    async handleSubmit() {
      if (this.isCareers) {
        this.handleCareersForm();
      } else {
        this.handlePressReleaseForm();
      }
    },

    async handleCareersForm() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });

      let fileJSON = {};
      fileJSON = Object.assign(fileJSON, this.careersForm);

      const { S3Path, directoryKey } = this.careersID;

      const uniqueID = uuid.v4();
      const identifier = `${S3Path}${uniqueID}/`;

      const newIndex = {
        header: fileJSON.role,
        date: fileJSON.date,
        id: identifier,
      };

      const file = { fileJSON, identifier, newIndex, directoryKey };

      await this.load(this.addFileToS3(file), "Uploading file");

      this.$router.push({
        name: "Careers",
      });
    },

    async handlePressReleaseForm() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });

      let fileJSON = {};
      fileJSON = Object.assign(fileJSON, this.pressReleaseForm);

      const { S3Path, directoryKey } = this.pressReleasesID;

      const uniqueID = uuid.v4();
      const identifier = `${S3Path}${uniqueID}/`;

      const newIndex = {
        header: fileJSON.header,
        subheader: fileJSON.subheader,
        date: fileJSON.date,
        featured: fileJSON.featured,
        homeFeatured: fileJSON.homeFeatured,
        id: identifier,
      };

      const file = {
        fileJSON,
        identifier,
        newIndex,
        directoryKey,
      };

      await this.load(this.addFileToS3(file), "Uploading file");

      this.$router.push({
        name: "Media",
      });
    },
  },

  created() {
    this.isCareers = this.$route.params.path === "job posting";
  },
};
</script>
